<template>
  <!-- 最终受益人信息 -->
  <div>
    <!-- 编辑模式：添加按钮 + 列表 -->
    <template v-if="!isReadonly">
      <div class="pb30">
        <el-button type="primary" plain icon="el-icon-circle-plus-outline" @click="addHandle" class="fs12">{{ $t("enroll.questionnaire.addBeneficiary") }}</el-button>
      </div>
      <div v-if="innerList.length != 0">
        <el-table :data="innerList" border class="wdb100">
          <el-table-column prop="memberType" :label="$t('enroll.intitle.type')" align="center">
            <template slot-scope="scope">
              <p>{{ getGlobalLabel("memberTypeList", scope.row.memberType) }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="fullName" :label="$t('enroll.intitle.compellation')" align="center"></el-table-column>
          <el-table-column prop="nationality" :label="$t('enroll.questionnaire.countryOrNationality')" align="center"></el-table-column>
          <el-table-column prop="phone" :label="$t('enroll.intitle.phone')" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.phone">{{ formatPhone(scope.row.phone) }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="email" :label="$t('enroll.intitle.email')" align="center"></el-table-column>
          <el-table-column :label="$t('common.operation')" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" class="mr6" @click="editHandle(scope.$index, scope.row)">{{ $t("common.button.edit") }}</el-button>
              <el-button type="text" icon="el-icon-delete" class="red" @click="deleteHandle(scope.$index, scope.row)">{{ $t("common.button.delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>

    <!-- 回显模式：直接平铺展示受益人详情 -->
    <template v-else>
      <div v-for="(row, index) in normalizedList" :key="`beneficiaryView-${index}`" class="beneficiaryViewCard">
        <p class="blueDark viewCardTitle">
          {{ getGlobalLabel("memberTypeList", row.memberType) }}
        </p>
        <company-form-panel v-if="row.memberType === 'CORPORATE'" :form="row" :isReadonly="true" :isMalaysia="isMalaysia"></company-form-panel>
        <personal-form-panel v-else :form="row" :isReadonly="true" :isMalaysia="isMalaysia"></personal-form-panel>
      </div>
    </template>

    <p class="pt10 fs12 lh16 crgy919">{{ $t("enroll.intitle.suggest") }}</p>

    <!-- 新建/编辑 - 弹窗(编辑模式专用) -->
    <add-or-update
      v-if="!isReadonly"
      :isReadonly="isReadonly"
      :isMalaysia="isMalaysia"
      ref="addOrUpdateRef"
      :shareholderDataList="shareholderDataList"
      @update="updateItem"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate.vue";
import CompanyFormPanel from "./modal/CompanyFormPanel.vue";
import PersonalFormPanel from "./modal/PersonalFormPanel.vue";
import { normalizeCompanyForm, normalizePersonalForm } from "./modal/formFactory";
import { mapGetters } from "vuex";
export default {
  name: "FinalBeneficiaryInformation",
  components: { AddOrUpdate, CompanyFormPanel, PersonalFormPanel },
  props: {
    /** v-model 绑定值：最终受益人信息数组 */
    value: { type: Array, default: () => [] },
    /** 股东/董事信息列表（用于拷贝功能） */
    shareholderDataList: { type: Array, default: () => [] },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    /** 是否马来西亚（用于显示马来专属的注册地址/服务地址模块） */
    isMalaysia: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters("constant", ["getGlobalLabel"]),
    /** 内部列表，与 value 保持同步 */
    innerList() {
      return this.value || [];
    },
    /** 回显模式：归一化后的受益人列表(补全缺失字段/嵌套对象，避免模板访问 undefined 报错) */
    normalizedList() {
      return this.innerList.map(row => (row.memberType === "CORPORATE" ? normalizeCompanyForm(row) : normalizePersonalForm(row)));
    },
  },
  methods: {
    /**
     * 格式化手机号显示（state + phone 组合 → xxx-xxxx）
     * 兼容旧格式（带区号前缀）和新格式（不带前缀）
     */
    formatPhone(phoneVal) {
      if (!phoneVal) return "";
      // 如果已经是 "xxx-xxxx" 格式，直接返回；否则拼接
      if (String(phoneVal).includes("-")) {
        return phoneVal.replace("+", "");
      }
      return String(phoneVal).replace("+", "");
    },
    /** 同步变更到父组件 */
    emitInput(newList) {
      this.$emit("input", newList);
    },
    // 添加最终受益人 - 按钮
    addHandle() {
      this.$refs.addOrUpdateRef.init("add");
    },
    // 编辑 - 最终受益人信息
    editHandle(index, row) {
      this.$refs.addOrUpdateRef.init(index, row);
    },
    // 删除 - 最终受益人信息
    deleteHandle(index) {
      const list = [...this.innerList];
      list.splice(index, 1);
      this.emitInput(list);
    },
    // 子组件触发更新（新增或编辑回调）
    updateItem(obj, index) {
      let list = JSON.parse(JSON.stringify(this.innerList));
      if (index === "add") {
        list.push(obj);
      } else {
        list.splice(index, 1, obj);
      }
      this.emitInput(list);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 回显模式 - 受益人详情卡片 */
.beneficiaryViewCard {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 0 20px 10px;
  margin-bottom: 20px;

  .viewCardTitle {
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    border-bottom: 1px solid #e4e7ed;
  }
}
</style>
